/* ============================================================
   Box Select E2 — mobile tier-pick canvas controller
   (Claude Design handoff, implemented 2026-06-10)

   The #gb-e2 markup (in sections/gift-builder.liquid) is the mobile
   pre-selection canvas: size cards + example photo + next-step CTA.
   This wires it to the EXISTING builder logic without touching it:

   - Tapping a number card PAINTS a pending tier (hero image, accessible description
     and the number of gifts in the CTA). It does NOT commit.
   - The dark "Choose N gifts" CTA commits by calling the existing
     window.gbSelectBoxTier(tier, realCard) on the matching hidden
     .gb-tier-card — so item-limit checks, the product reveal, the
     mobile-tier-selected flip, haptics, etc. all run unchanged.

   Prices are read from the card markup (Liquid rendered them market-aware
   via gb_sym/gb_rate), so AU $ and UK £ both stay correct with no JS map.
   ============================================================ */
(function () {
  function init() {
    var e2 = document.getElementById('gb-e2');
    if (!e2 || e2.dataset.wired === '1') return;
    e2.dataset.wired = '1';

    var cols       = e2.querySelectorAll('.gb-e2-col');
    var hero       = document.getElementById('gb-e2-hero');
    var shippingEl = document.getElementById('gb-e2-shipping-label');
    var cta        = document.getElementById('gb-e2-cta');
    var ctaCount   = document.getElementById('gb-e2-cta-count');

    var pending = e2.getAttribute('data-default-tier') || 'twilight';
    /* The default tier's hero image + texts are server-rendered in the
       section markup (2026-06-11), so the initial paint(pending) call must
       NOT restart the hero cross-fade — that re-faded an already-correct
       image on every load (part of the mobile "vibrates on load" report).
       The fade now only runs when the tier actually changes. */
    var paintedTier = e2.getAttribute('data-default-tier') || 'twilight';
    var HERO_TONE = { dusk: '#685545', twilight: '#67594e', midnight: '#403731' };

    function txt(el, sel) { var n = el.querySelector(sel); return n ? n.textContent.trim() : ''; }

    function paint(tier) {
      var col = e2.querySelector('.gb-e2-col[data-tier="' + tier + '"]');
      if (!col) return;
      pending = tier;

      for (var i = 0; i < cols.length; i++) {
        cols[i].classList.toggle('is-active', cols[i] === col);
        cols[i].setAttribute('aria-pressed', cols[i] === col ? 'true' : 'false');
      }

      var name  = txt(col, '.gb-e2-col__name');
      var items = col.getAttribute('data-items');

      if (hero) {
        var tierChanged = tier !== paintedTier;
        hero.style.backgroundColor = HERO_TONE[tier] || HERO_TONE.twilight;
        if (tierChanged || !hero.style.backgroundImage) {
          hero.style.backgroundImage = "url('" + col.getAttribute('data-hero') + "')";
        }
        if (tierChanged) {
          // restart the cross-fade — real changes only, never the initial call
          hero.classList.remove('gb-e2-hero--fade');
          void hero.offsetWidth;
          hero.classList.add('gb-e2-hero--fade');
        }
        paintedTier = tier;
      }
      if (ctaCount) ctaCount.textContent = items;
      if (hero) hero.setAttribute('aria-label', 'Example ' + name + ' arrangement with ' + items + ' gifts. You choose what goes inside.');
      if (shippingEl) shippingEl.textContent   = col.getAttribute('data-shipping-label') || 'AU-wide delivery';
    }

    for (var i = 0; i < cols.length; i++) {
      (function (c) {
        c.addEventListener('click', function () { paint(c.getAttribute('data-tier')); });
      })(cols[i]);
    }

    if (cta) {
      cta.addEventListener('click', function () {
        var realCard = document.querySelector('.gb-tier-card[data-tier="' + pending + '"]');
        if (realCard && typeof window.gbSelectBoxTier === 'function') {
          window.gbSelectBoxTier(pending, realCard);
        }
      });
    }

    // If the user returns to the tier-pick canvas via "Change box", reflect
    // whichever tier is currently committed (falls back to the default).
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.gb-tsb-change, .gb-bar-change, #ss-change-size-btn')) {
        setTimeout(function () {
          var sel = document.querySelector('.gb-tier-card.selected');
          if (sel && sel.getAttribute('data-tier')) paint(sel.getAttribute('data-tier'));
        }, 0);
      }
    }, true);

    paint(pending);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
